import React, { useCallback, useRef, useState } from 'react'
import swal from 'sweetalert';
import Breadcrumb from '../../component/Breadcrumb'
import { Box, Grid, Input, TextField, Typography, FormLabel } from '@mui/material';
import FormButtons from '../../component/FormSubmitCancelButtons';
import Loader from '../../component/Loader/Loader';
import { sendFeedBackRequest } from '../../api/mappingApi';


const Feedback = () => {

    const hiddenFileInput               =  useRef(null);
    const [file,setFile]                =  useState([]);
    const [message,setMessage]          =  useState('');
    const [username,setUsername]        =  useState('');
    const [email,setEmail]              =  useState('');
    const [showLoader, setShowLoader]   =  useState(false);

    const handleFileChange = useCallback((event) => {
      let fileUpload = event.target.files[0];
      setFile(fileUpload);
    },[]);
    
    const submitForm = async () => {
      if(message === '' || username === '' || email === ''){
        swal({title: "Error", text: "Please fill required fields.",icon: "error"})
        return;
      }
    
      if(!(/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email))){
        swal({title: "Error", text: "Email Address is not vaild.",icon: "error"})
        return;
      }

      const formData = new FormData(); 
      formData.append('file', file);
      formData.append('name', username);
      formData.append('email', email);
      formData.append('message', message);
      setShowLoader(true);
      await(sendFeedBackRequest(formData));
      setShowLoader(false);
      swal({
        title: "Success",
        text: 'Message send successfully.',
        icon: "success",
      })
      resetForm();
    };

    const resetForm = () => {
      hiddenFileInput.current.value = null;
      setMessage('');
      setUsername('');
      setEmail('');
    };

    return (
        <>
            {showLoader && 
              <Loader />
            }
            <Breadcrumb title="Feedback & Help Request Form">
                <Typography variant="subtitle2" color="#8C8C8C" className="link-breadcrumb">
                Help
                </Typography>
                <Typography variant="subtitle2" className="link-breadcrumb">
                FeedBack
                </Typography>
            </Breadcrumb>
            <Box component="section">
                <Grid className="contentBox">
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={12} md={4} >
                            <FormLabel style={{color:"#8C8C8C"}}>Name</FormLabel>
                            <TextField
                                fullWidth 
                                margin='desnse'
                                value={username}
                                name="username"
                                onChange={(e) => setUsername(e.target.value)}
                                error={username === ""}
                                helperText={username === "" ? "Required Field!" : " "}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} >
                            <FormLabel style={{color:"#8C8C8C"}}>Email</FormLabel>
                            <TextField
                                fullWidth 
                                margin='desnse'
                                value={email}
                                name="email"
                                onChange={(e) => setEmail(e.target.value)}
                                error={email === "" || !(/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email))}
                                helperText={email === "" ? "Required Field!" :  !(/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) ? 'Email Address is not vaild!'  :  " "  }
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                            <FormLabel style={{color:"#8C8C8C"}}>Upload Document</FormLabel>
                            <Input
                                type="file"
                                fullWidth 
                                margin='desnse'
                                name="file"
                                onChange={handleFileChange} 
                                ref={hiddenFileInput}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                      <Grid item xs={12} sm={12} md={12} >
                          <FormLabel style={{color:"#8C8C8C"}}>Message</FormLabel>
                          <TextField
                            margin="dense"
                            fullWidth 
                            multiline
                            name="message"
                            minRows={8}
                            onChange={(e) => setMessage(e.target.value)}
                            value={message}
                            error={message === ""}
                            helperText={message === "" ? "Required Field!" : " "}
                          />
                      </Grid>
                    </Grid>
                    <FormButtons onSubmit={submitForm}  onCancel={resetForm} />
                </Grid>
            </Box>
        </>
    )
}

export default Feedback